import { render } from "./BackButton.vue?vue&type=template&id=af50860c&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=af50860c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af50860c"]])

export default __exports__